// Otto is LineSide's ownerless Chief AI Officer, available to Superadmins.
// Every user-visible default goes through these constants; an agent's own
// name (from /api/agents) always wins where one is known.
export const LEAD_AGENT_NAME = 'Otto';
export const LEAD_AGENT_TITLE = 'Chief AI Officer';
export const AGENT_BRAND = LEAD_AGENT_NAME;

export const agentName = (agent, fallback = AGENT_BRAND) =>
  String(agent?.display_name || agent?.name || '').trim() || fallback;
